module.exports = __webpack_public_path__ + "img/avatar.19e749cd.svg";